export default {"src":"/_next/static/media/artefact_dark.3cb06a37.svg","height":300,"width":900,"blurWidth":0,"blurHeight":0};